import { useState, useEffect, useRef } from 'react';
import { Button} from '@mui/material';
import { jaJP } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box } from "@mui/material";
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import BackspaceIcon from '@mui/icons-material/Backspace';
import DoneIcon from '@mui/icons-material/Done';
import { useAuth } from '../../contexts/AuthContext';
import { usePost } from '../../apis/ApiRequests';
import { CustomDataGrid } from '../../components/dataGrid/CustomDataGrid';
import CustomSnackBar from '../../components/alert/CustomSnackBar';
import CustomConfirm from '../../components/confirm/CustomConfirm';
import Header from '../../components/Header';
import Frame from '../../components/uiParts/Frame';
import TitleBar from '../../components/uiParts/TitleBar';
import MastaSearchForm from '../../components/uiParts/maintenance/MastaSearchForm';
import CustomOutlinedInput from '../../components/input/CustomOutlinedInput';
import CustomCheckbox from '../../components/input/CustomCheckbox';
import CustomSelect from '../../components/select/CustomSelect';
import { fishStyleList } from '../../Store';
import { read, utils } from 'xlsx';

const OriginalFishSpecList = () => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - ベース情報を取得
	//-----------------------------------------------
    const { authInfo } = useAuth();
    const facilityCode = authInfo.facilityCode;
    const facilityName = authInfo.facilityName;
    const userId       = authInfo.userId;
    const userName     = authInfo.userName;
    const authority    = authInfo.authority;
    
	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [dataGridHeight, setDataGridHeight] = useState(window.innerHeight - 250);
    const [condition , setCondition] = useState('');
    const [originalFishSpecList, setOriginalFishSpecList] = useState([]);
    const [standardList, setStandardList] = useState([]);
    const [searchCount, setSearchCount] = useState(0);
    const [targetList, setTargetList] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [requireMessage, setRequireMessage] = useState('');
    const [excelDataList, setExcelDataList] = useState([]);
    const [excelImportFlag, setExcelImportFlag] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    
    // 登録データ
    const [registerData, setRegisterData] = useState({
        code : '',
        kikakuCode : 0,
        nisugataKubun : 0,
        name : '',
        displayName : '',
        nameKana : '',
        displayNo : '',
        kikaku : '',
        nisugata : '',
        originalCode : '',
        originalName : '',
        mizubikiPer : 0,
        limitSuryo : 0,
        suryoReqFlag : '0',
        codePrev : '',
        kikakuCodePrev : 0,
        nisugataKubunPrev : 0,
    });
    // UI Message
    const [messageState, setMessageState] = useState({
        snackBarTrue   : false,
        snackBarFalse  : false,
        require        : false,
    });
    
	//-----------------------------------------------
    // initialize - useRef
	//-----------------------------------------------
    const fileInputRef = useRef()
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - searchData / masta_OriginalFishSpec
	//-----------------------------------------------
    const { response : searchData_Res, loading : searchData_Loading, post:searchData_Post } = usePost();
    const searchData = async () => {
        const postData = {
            'className'    : 'mch.models.masta.OriginalFishSpec',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'keyword1'     : condition
        }
        await searchData_Post(postData);
    };
	//-----------------------------------------------
    // API - setData / masta_OriginalFishSpec
	//-----------------------------------------------
    const { response : setData_Res, loading : setData_Loading, post:setData_Post } = usePost();
    const setData = async (registerData) => {
        const postData = {
            'className'         : 'mch.models.masta.OriginalFishSpec',
            'methodName'        : 'setDataForHistory',
            'facilityCode'      : facilityCode,
            'userId'            : userId,
            'activeFlag'        : registerData.activeFlag,
            'code'              : registerData.code,
            'kikakuCode'        : registerData.kikakuCode,
            'nisugataKubun'     : registerData.nisugataKubun,
            'name'              : registerData.name,
            'displayName'       : registerData.displayName,
            'nameKana'          : registerData.nameKana,
            'displayNo'         : registerData.displayNo,
            'kikaku'            : registerData.kikaku,
            'nisugata'          : registerData.nisugata,
            'originalCode'      : registerData.originalCode,
            'originalName'      : registerData.originalName,
            'mizubikiPer'       : registerData.mizubikiPer,
            'limitSuryo'        : registerData.limitSuryo,
            'suryoReqFlag'      : registerData.suryoReqFlag,
            'codePrev'          : registerData.codePrev,
            'kikakuCodePrev'    : registerData.kikakuCodePrev,
            'nisugataKubunPrev' : registerData.nisugataKubunPrev,
        }
        await setData_Post(postData);
    };
	//-----------------------------------------------
    // API - searchData / masta.Standard
	//-----------------------------------------------
    const { response : getDataAll_standard_res, post : getDataAll_standard_post } = usePost();
    const getDataAll_standard = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Standard',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_standard_post(postData);
    };
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        setSearchCount(searchCount+1);
        getDataAll_standard();
        
        const handleResize = () => {
          setDataGridHeight(window.innerHeight - 250);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    },[]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_standard)
	//-----------------------------------------------
    useEffect(() => {
        setStandardList([]);
        if (getDataAll_standard_res) {
            setStandardList(getDataAll_standard_res.Data);
        }
    }, [getDataAll_standard_res]);
	//-----------------------------------------------
    // useEffect - APIコール（検索処理）
	//-----------------------------------------------
    useEffect(() => {
        setOriginalFishSpecList([]);
        if (searchData_Res) {
            setOriginalFishSpecList(searchData_Res.Data);
        }
    }, [searchData_Res]);
	//-----------------------------------------------
    // useEffect - APIコール（登録処理）
	//-----------------------------------------------
    useEffect(() => {
        if (setData_Res) {
            setOpenDialog(false);
            if(!isProcessing){
                setMessageInfo('confirm', false);
                setMessageInfo('snackBarTrue', true);
            }
            setSearchCount(searchCount+1);
        }
    }, [setData_Res]);
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        searchData();
    }, [searchCount]);
    //-----------------------------------------------
    // useEffect - dataGirdの選択
    //-----------------------------------------------
    useEffect(() => {
        if (targetList) {
            setRegisterData({ ...targetList,
                codePrev: targetList.code,
                kikakuCodePrev: targetList.kikakuCode,
                nisugataKubunPrev: targetList.nisugataKubun,
            });
            setOpenDialog(true); // ダイアログを表示
        }
    }, [targetList]);
	//-----------------------------------------------
    // useEffect - エクセルファイル取り込み処理
	//-----------------------------------------------
    useEffect(() => {
        const importSequentially = async () => {
            if (!excelImportFlag) return;

            for (const item of excelDataList) {
                const registerData = {
                    'activeFlag'    : 1,
                    'code'          : item.code,
                    'kikakuCode'    : item.kikakuCode,
                    'nisugataKubun' : item.nisugataKubun,
                    'name'          : item.name,
                    'displayName'   : item.displayName,
                    'nameKana'      : item.nameKana,
                    'displayNo'     : item.displayNo,
                    'kikaku'        : item.kikaku,
                    'nisugata'      : item.nisugata,
                    'originalCode'  : item.originalCode,
                    'originalName'  : item.originalName,
                    'mizubikiPer'   : item.mizubikiPer,
                    'limitSuryo'    : item.limitSuryo
                };
                try {
                    await setData(registerData);
                } catch (err) {
                }
            }
            setExcelImportFlag(false);
            setIsProcessing(false);
            setMessageInfo('confirm_excel', false);
        };
        importSequentially();
    }, [excelDataList, excelImportFlag]);

	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 検索ボタン
	//-----------------------------------------------
    const handleClick_search = () => {
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
    // eventHandler - 検索クリアボタン
	//-----------------------------------------------
    const handleClick_search_clear = () => {
        setCondition('');
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
    // eventHandler - データの設定
	//-----------------------------------------------
    const handleChange = (name, value) => {
        setRegisterData(prevSearchData => ({
            ...prevSearchData,
            [name]: value,
        }));
    };
	//-----------------------------------------------
    // eventHandler - 新規ボタン
	//-----------------------------------------------
    const handleClick_new = () => {
        setRegisterData({
            code : '',
            kikakuCode : 0,
            nisugataKubun : 0,
            name : '',
            displayName : '',
            nameKana : '',
            displayNo : '',
            kikaku : '',
            nisugata : '',
            originalCode : '',
            originalName : '',
            mizubikiPer : 0,
            militSuryo : 0,
            suryoReqFlag : '0',
            codePrev : '',
            kikakuCodePrev : '',
            nisugataKubunPrev : '',
        })
        setTargetList('');
        setOpenDialog(true);
    };
	//-----------------------------------------------
    // eventHandler - 登録ボタン
	//-----------------------------------------------
    const handleClick_Register = (activeFlag) => {
        const targetData = { ...registerData, activeFlag };
        const requireStatus = checkedRequire(); // 必須項目をチェックする
        if (requireStatus) {
            setData(targetData);
        } else {
            setMessageInfo('require', true);
        }
    };
	//-----------------------------------------------
    // eventHandler - ダイアログを非表示
	//-----------------------------------------------
    const handleClick_dialog_close = () => {
        setOpenDialog(false);
        setTargetList('');
    };
	//-----------------------------------------------
    // eventHandler - EXCELファイルの取り込み
	//-----------------------------------------------
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = read(data, { type: 'array' });
    
                const sheetName = '魚種'; // 読み込むシート名
                const worksheet = workbook.Sheets[sheetName];
    
                if (!worksheet) {
                    setRequireMessage('指定されたシート名が存在しません。');
                    setMessageInfo('require', true);
                    return;
                }
                // シートからデータをJSON形式で取得
                const jsonData = utils.sheet_to_json(worksheet, { header: 1 });
                const rows = jsonData.map((row, index) => {
                    if (index === 0) return null; // ヘッダー行をスキップ
                    return {
                        originalCode: row[0],
                        originalName: row[1],
                        code: row[2],
                        name: row[3],
                        displayName: row[4] || '',
                        kikakuCode: row[5],
                        kikaku: row[6],
                        nisugataKubun: row[7],
                        nisugata: row[7] ? '活魚' : '鮮魚',
                        nameKana: row[8] || '',
                        mizubikiPer: row[9],
                        limitSuryo: row[10],
                        displayNo: index,
                    };
                }).filter(row => row !== null)
                setMessageInfo('confirm_excel', true);
                setExcelDataList(rows);
            };
            reader.readAsArrayBuffer(file);
        }
    };
	//-----------------------------------------------
    // eventHandler - EXCELファイルの参照
	//-----------------------------------------------
    const handeliClick_excel = () => {
        fileInputRef.current.click();
    };
    const handliClick_excelImportOK = () => {
        setExcelImportFlag(true);
        setIsProcessing(true);
        setMessageInfo('snackBarTrue', false);
    };
	//-----------------------------------------------
	// eventHandler - 権限の変更の変更
	//-----------------------------------------------
    const handleChangexNisugata = (value) => {
        handleChange('nisugataKubun', value);
        const item = fishStyleList.find(fish => fish.id === value);
        item ? handleChange('nisugata', item.name) : handleChange('nisugata', '');
    };
	//-----------------------------------------------
	// eventHandler - 権限の変更の変更
	//-----------------------------------------------
    const handleChangexStandard = (value) => {
        handleChange('kikakuCode', value);
        const item = standardList.find(fish => fish.code === value);
        item ? handleChange('kikaku', item.name) : handleChange('kikaku', '');
    };
    //===============================================
    // dataGird
    //===============================================
    //-----------------------------------------------
    // dataGird - テーブルの見出し
    //-----------------------------------------------
    const columns = [
        { field: 'displayNo', headerName: '表示No',  width: 80, columnSeparatorWidth: 1, type:'number', },
        { field: 'originalCode', headerName: '販売管理コード', width: 120, columnSeparatorWidth: 1, },
        { field: 'originalName', headerName: '販売管理名称', width: 150, columnSeparatorWidth: 1, },
        { field: 'code', headerName: 'コード', width: 80, columnSeparatorWidth: 1, },
        { field: 'name', headerName: '名称', width: 120, columnSeparatorWidth: 1, },
        { field: 'kikaku', headerName: '規格', width: 150, columnSeparatorWidth: 1, },
        { field: 'nisugata', headerName: '荷姿', width: 80, columnSeparatorWidth: 1, },
        { field: 'mizubikiPer', headerName: '水引き(%)', width: 80, columnSeparatorWidth: 1, },
        { field: 'limitSuryo', headerName: '水槽容量(Kg)', width: 120, columnSeparatorWidth: 1, },
        { field: 'suryoReqFlag', headerName: '数量必須', width: 100, columnSeparatorWidth: 1,
            valueGetter: (params) => (params.row.suryoReqFlag == 1 ? '有効' : ''),
        },
    ]
    //-----------------------------------------------
    // dataGrid - 行の選択
    //-----------------------------------------------
    const handleClick_dataGrid = (event) => {
        setTargetList(event.row);
    }
	//===============================================
	// Function
	//===============================================
	//-----------------------------------------------
	// Function - 必須項目をチェックする
	//-----------------------------------------------
    const checkedRequire = () => {
        const errorFields = [];
    
        if (!registerData.code) errorFields.push('「コード」');
        if (!registerData.name) errorFields.push('「名称」');
        if (!registerData.originalCode) errorFields.push('「販売管理コード」');
    
        if (errorFields.length) {
            const text = errorFields.join('、') + 'が入力されていません';
            setRequireMessage(text);
            return false;
        }
        return true;
    }
	//===============================================
	// UI Message
	//===============================================
    const setMessageInfo = (target, state) => {
        setMessageState(prevSearchData => ({
            ...prevSearchData,
            [target]: state,
        }));
    };
    //===============================================
    // Css
    //===============================================
    const dialog_button_close = { 
        fontSize: '16px', height:'40px', width:'320px', color:'#fff', backgroundColor:'#808080'
    }
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/bidMastaMenu" />
            <div className='originalFishSpecList bodyContens'>
                <TitleBar title="魚種マスタ一覧" />
                <div className='mainContents'>
                    <Frame classname="frame" title="マスタ検索">
                        <MastaSearchForm
                            id                = "originalFishSpecList_condition"
                            value             = { condition }
                            handleChange      = { (e) => setCondition(e.target.value) }
                            handleSearch      = { () => handleClick_search() }
                            handleSearchClear = { () => handleClick_search_clear() }
                            handleClickNew    = { () => handleClick_new() }
                            excelRef            = { fileInputRef }
                            handleExcelOnchange = { (e) => handleFileChange(e) }
                            handleExcelClick    = { (e) => handeliClick_excel(e) }
                        />
                    </Frame>
                    <Frame classname="frame" title="マスタ一覧">
                        <CustomDataGrid
                            getRowClassName={(params) =>
                                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                            }
                            editMode                = "row"
                            rows                    = { originalFishSpecList }
                            columns                 = { columns }
                            sx                      = { {height:dataGridHeight,fontSize:14,borderColor: 'primary.light',} }
                            density                 = "compact"
                            localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                            showColumnRightBorder
                            showCellRightBorder
                            initialState            = {{pagination: { paginationModel: { pageSize: 100 } },}}
                            pageSizeOptions         = {[50, 100, 150, 200]}
                            loading                 = { searchData_Loading }
                            onCellClick             = {(event) => handleClick_dataGrid(event)}
                        />
                    </Frame>
                </div>
            </div>
            <div className='originalFishSpecList_dialog'>
                <Dialog open={ openDialog } onClose={ handleClick_dialog_close } maxWidth='lg' >
                    <DialogTitle>
                        <TitleBar title="魚種マスタ登録" />
                    </DialogTitle>
                    <DialogContent style={{border:'none'}} sx = {{width:'auto'}}>
                        <div style={{backgroundColor:'#efefef', padding:'10px'}}>
                            <Box display="flex" gap={2}>
                                <CustomOutlinedInput
                                    id       = "originalFishSpecList_code"
                                    label    = "コード"
                                    value    = { registerData.code }
                                    width    = "200px"
                                    onChange = {(e) => handleChange('code', e.target.value)}
                                />
                                <CustomOutlinedInput
                                    id       = "originalFishSpecList_name"
                                    label    = "名称"
                                    value    = { registerData.name }
                                    width    = "200px"
                                    onChange = {(e) => handleChange('name', e.target.value)}
                                />
                            </Box>
                            <Box display="flex" gap={2} style={{marginTop:'10px'}}>
                                <CustomOutlinedInput
                                    id       = "originalFishSpecList_displayName"
                                    label    = "表示名称"
                                    value    = { registerData.displayName }
                                    width    = "200px"
                                    onChange = {(e) => handleChange('displayName', e.target.value)}
                                />
                                <CustomOutlinedInput
                                    id    = "originalFishSpecList_nameKana"
                                    label = "カナ名称"
                                    value = { registerData.nameKana }
                                    width = "200px"
                                    onChange = {(e) => handleChange('nameKana', e.target.value)}
                                />
                            </Box>
                            <Box display="flex" gap={2} style={{marginTop:'10px'}}>
                                <CustomSelect
                                    id         = "originalFishSpecList_authority"
                                    label      = "規格"
                                    width      = "200px"
                                    dataList   = {standardList} 
                                    selectedId = {registerData.kikakuCode} 
                                    onChange   = {(e) => handleChangexStandard(e.target.value)} 
                                />
                                <CustomSelect
                                    id         = "originalFishSpecList_authority"
                                    label      = "荷姿"
                                    width      = "200px"
                                    dataList   = {fishStyleList} 
                                    selectedId = {registerData.nisugataKubun}
                                    onChange   = {(e) => handleChangexNisugata(e.target.value)} 
                                />
                            </Box>
                            <Box display="flex" gap={2} style={{marginTop:'10px'}}>
                                <CustomOutlinedInput
                                    id       = "originalFishSpecList_displayNo"
                                    label    = "表示No"
                                    value    = { registerData.displayNo }
                                    width    = "200px"
                                    onChange = {(e) => handleChange('displayNo', e.target.value)}
                                />
                            </Box>
                            <Box display="flex" gap={2} style={{marginTop:'10px'}}>
                                <CustomOutlinedInput
                                    id       = "originalFishSpecList_limitSuryo"
                                    label    = "水槽容量"
                                    value    = { registerData.limitSuryo }
                                    width    = "200px"
                                    onChange = {(e) => handleChange('limitSuryo', e.target.value)}
                                />
                                <CustomOutlinedInput
                                    id       = "originalFishSpecList_displayNo"
                                    label    = "水引き(%)"
                                    value    = { registerData.mizubikiPer }
                                    width    = "200px"
                                    onChange = {(e) => handleChange('mizubikiPer', e.target.value)}
                                />
                            </Box>
                            <Box display="flex" gap={2} style={{marginTop:'10px'}}>
                                <CustomOutlinedInput
                                    id       = "originalFishSpecList_displayNo"
                                    label    = "販売管理コード"
                                    value    = { registerData.originalCode }
                                    width    = "200px"
                                    onChange = {(e) => handleChange('originalCode', e.target.value)}
                                />
                                <CustomOutlinedInput
                                    id       = "originalFishSpecList_displayNo"
                                    label    = "販売管理名称"
                                    value    = { registerData.originalName }
                                    width    = "200px"
                                    onChange = {(e) => handleChange('originalName', e.target.value)}
                                />
                            </Box>
                            <Box display="flex" style={{marginTop:'10px'}}>
                                <CustomCheckbox
                                    label          = "数量必須"
                                    defaultChecked = { registerData.suryoReqFlag == 1 }
                                    onChange       = { (e) => handleChange('suryoReqFlag', e.target.checked ? '1' : '0') }
                                />
                            </Box>
                            <Box display="flex" sx={{justifyContent: "center",marginTop: 2,}}>
                                <Button
                                    color     = "attention"
                                    size      = "large"
                                    variant   = "contained"
                                    sx        = {{width:'140px', color:'#fff'}}
                                    onClick   = { () => setMessageInfo('confirm', true) }
                                    startIcon = {<BackspaceIcon />}
                                >{'削除'}
                                </Button>
                                <Button
                                    color     = "primary"
                                    size      = "large"
                                    variant   = "contained"
                                    sx        = {{width:'140px', marginLeft:'10px'}}
                                    onClick   = { () => handleClick_Register(1) }
                                    startIcon = {<DoneIcon />}
                                >{'登録'}
                                </Button>
                            </Box>
                        </div>
                        <Box display="flex" sx={{justifyContent: "center",marginTop: 2,}}>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                onClick   = {() => handleClick_dialog_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </Box>
                    </DialogContent>
                </Dialog>
                <CustomSnackBar
                    open            = {messageState.snackBarTrue}
                    onClose         = {() => setMessageInfo('snackBarTrue', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "登録しました"
                />
                <CustomSnackBar
                    open            = {messageState.snackBarFalse}
                    onClose         = {() => setMessageInfo('snackBarFalse', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = "登録に失敗しました"
                />
                <CustomSnackBar
                    open            = {messageState.require}
                    onClose         = {() => setMessageInfo('require', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = {requireMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm}
                    onClose   = {() => setMessageInfo('confirm', false)}
                    onClickNG = {() => setMessageInfo('confirm', false)}
                    onClickOK = {() => handleClick_Register(0)}
                    message   = "指定データの削除を行います。よろしいですか？"
                />
                <CustomConfirm
                    open      = {messageState.confirm_excel}
                    onClose   = {() => setMessageInfo('confirm_excel', false)}
                    onClickNG = {() => setMessageInfo('confirm_excel', false)}
                    onClickOK = {() => handliClick_excelImportOK()}
                    isProcessing = {isProcessing}
                    message   = "エクセルファイルのアップロードを行います。よろしいですか？"
                />
            </div>
        </>
    )
}
export default OriginalFishSpecList;